/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Change tag request
 */
export interface UpdateWithdrawTagRequest {
  /**
   * Main account or subaccount ID. Main account is used if not set
   */
  accountId?: number;
  /**
   * Withdraw info ID.
   */
  withdrawInfoId: number;
  /**
   * New tag.
   */
  tag: string;
}
